import { z } from "zod";
import { Country } from "../Country.js";
import { nonEmptyString } from "./nonEmptyString.js";

export const handlerInputSchema = z.object({
	email: nonEmptyString.email(),
	firstName: nonEmptyString,
	homeland: z.nativeEnum(Country),
	lastName: nonEmptyString,
	member: z.boolean(),
});
